import React from 'react';
import {useTranslation} from "react-i18next";
import {APICore} from "../helpers/api/apiCore";
import {Button, Card, Col, Row} from "react-bootstrap";
import Loader from "./Loader";
import Table from "./Table";
import {Link} from "react-router-dom";
import DateTimeFormatter from "./DateTimeFormatter";
import CurrencyFormatter from "./CurrencyFormatter";


const EventDateColumn = ({ row }) => {

    return (
        <>
            <Link to={"/event_coaches/" + row.original.id} className="text-body fw-bold">
                <DateTimeFormatter date={row.original.event.start_date} time={row.original.event.start_time}/> <br/> -  <br/>
                <DateTimeFormatter date={row.original.event.end_date} time={row.original.event.end_time}/>
            </Link>
        </>
    );
};

const EventCoachCreatedDateColumn = ({ row }) => {
    return (
        <>
            {row.original.assignment_date} <br/>
            {row.original.viewed_date} <br/>
            {row.original.reply_date}
        </>
    )
};

/* orderdate column render */
const EventNameColumn = ({ row }) => {
    return (
        <>
            {row.original.event.name}
        </>
    );
};

/* orderdate column render */
const EventCoachStatusColumn = ({ row }) => {
    const {t } = useTranslation();

    if(row.original.status === "pending"){
        return (
            <>
                <span class="me-1 bg-primary badge bg-primary">{t("pending")}</span>
            </>
        );
    }
    else if (row.original.status === "accepted"){
        return (
            <>
                <span class="me-1 bg-success badge bg-success">{t("accepted")}</span>
            </>
        );
    }
    else if (row.original.status === "denied"){
        return (
            <>
                <span class="me-1 bg-danger badge bg-danger">{t("denied")}</span>
            </>
        );
    }
};


const addLineBreak = (str: string) =>
    str.split('\n').map((subStr) => {
        return (
            <>
                {subStr}
                <br />
            </>
        );
    });

const sizePerPageList = [
    {
        text: '25',
        value: 25,
    },
    {
        text: '50',
        value: 50,
    },
    {
        text: '100',
        value: 100,
    }
];


/* orderdate column render */
const EventCoachPriceColumn = ({ row }) => {
    return (
        <>
            <CurrencyFormatter price={row.original.price}/>
        </>
    );
};

const EventCoachTableView = (props): React$Element<React$FragmentType> => {

    const { t } = useTranslation();
    let columns = []
    const api = new APICore();
    let user = api.getLoggedInUser()

    const ActionColumn = ({row}) => {
        const {t } = useTranslation();

        return (
            <div className="col-md-12 text-center">

                <Link to={`/event_coaches/${row.original.id}`} className="action-icon mr-1">
                    <i className="mdi mdi-eye"></i>
                </Link>

                { window.location.pathname === "/event_coaches" ?
                    <Button disabled={row.original.status !== "pending"} variant="info" onClick={() => props.toggleSignIn(row.original)}>
                        {t("edit")}
                    </Button> : "" }

            </div>
        );
    };


    if(user.user.user.show_coach_price){
        columns = [
            {
                Header: t("start_date_or_end_date"),
                accessor: 'date',
                sort: true,
                Cell: EventDateColumn,
            },
            {
                Header: t("event_name"),
                accessor: 'name',
                sort: true,
                Cell: EventNameColumn,
            },
            {
                Header: t("price"),
                accessor: 'price',
                sort: true,
                Cell: EventCoachPriceColumn,
            },
            {
                Header: t("status"),
                accessor: 'status',
                sort: true,
                Cell: EventCoachStatusColumn,
            },
            {
                Header: addLineBreak(t("assignment_date") + "\n" + t("viewed_date") + "\n" + t("reply_date")),
                accessor: 'assignment_date',
                sort: true,
                Cell: EventCoachCreatedDateColumn,
            },
            {
                Header: t("action"),
                accessor: 'action',
                sort: false,
                classes: 'table-action',
                Cell: ActionColumn,
            },

        ];
    }else{
        columns = [
            {
                Header: t("start_date_or_end_date"),
                accessor: 'date',
                sort: true,
                Cell: EventDateColumn,
            },
            {
                Header: t("event_name"),
                accessor: 'name',
                sort: true,
                Cell: EventNameColumn,
            },
            {
                Header: t("status"),
                accessor: 'status',
                sort: true,
                Cell: EventCoachStatusColumn,
            },
            {
                Header: addLineBreak(t("assignment_date") + "\n" + t("viewed_date") + "\n" + t("reply_date")),
                accessor: 'assignment_date',
                sort: true,
                Cell: EventCoachCreatedDateColumn,
            },
            {
                Header: t("action"),
                accessor: 'action',
                sort: false,
                classes: 'table-action',
                Cell: ActionColumn,
            },

        ];
    }

    return (
        <>

            <Row>
                <Col xs={12}>
                    <Card>
                        { window.location.pathname === "/dashboard" ?
                        <Card.Header>
                            <h4>{t("coach_booking_request")}</h4>
                        </Card.Header> : null }
                        <Card.Body>

                            {props.loading && <Loader />}

                            <Table
                                columns={columns}
                                data={props.event_coaches}
                                pageSize={25}
                                sizePerPageList={sizePerPageList}
                                isSortable={true}
                                pagination={true}
                                isSelectable={false}
                                isSearchable={false}
                                theadClass="table-light"
                                searchBoxClass="mb-2"
                            />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    );
};

export default EventCoachTableView;